interface IGiveaway {
  id: number;
  sent_at: Date;
  recipient_name: string;
  recipient_email: string;
  status: string;
  beenRedeemed: boolean;
}

class Giveaway implements IGiveaway {
  id: number;
  sent_at: Date;
  recipient_name: string;
  recipient_email: string;
  status: string;

  constructor(attributes: IGiveaway) {
    Object.assign(this, attributes);
  }

  get beenRedeemed(): boolean {
    return ['redeemed', 'consumed'].includes(this.status);
  }
}

export { IGiveaway };
export default Giveaway;
